define.alias("ember-math-helpers/helpers/cos", "calendar/helpers/cos");